<template>
	<section>
		<ValidationObserver tag="form" ref="observer" @submit.prevent="handleSubmit()">
			<p class="f-14 f-m-12 margin-0"><strong>Data Kontak</strong></p>
		    <div class="row">
		        <div class="col">
					<div class="form-group mb-0">
						<label class="form-label">Nama</label>
						<ValidationProvider name="Nama" rules="required" v-slot="{ errors }">
							<input type="text" v-model="model.name" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nama">   
							<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
						</ValidationProvider>
					</div>

					<div class="form-group mb-0">
						<label class="form-label mt-2">Nomor telepon</label>
						<ValidationProvider name="Nomor telepon" rules="required|numeric" v-slot="{ errors }">
							<input type="text" v-model="model.phone_number" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor telepon">   
							<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
						</ValidationProvider>
					</div>

					<div class="form-group mb-0">
						<label class="form-label mt-2">Negara</label>
						<ValidationProvider name="Negara" rules="required" v-slot="{ errors }">
							<SelectOption placeholder="Cari Negara" url="country" label="country_name" keyId="id_country" :defaultId="model.id_country" @setValue="setValueCountry" :class="{ 'error': errors[0] }"/>
							<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
							<input type="hidden" v-model="model.id_country">
						</ValidationProvider>
					</div>
		        </div>
		        <div class="col m-m-0">
		            <div class="row">
		                <div class="form-group mt-0 col ml-0 mr-0">
							<label class="form-label">Kota atau kecamatan</label>
							<ValidationProvider name="Kota atau kecamatan" rules="required" v-slot="{ errors }">
								<SelectOption placeholder="Cari Kota atau kecamatan" url="location" label="kabupaten" keyId="id_location" :defaultId="model.id_location" @setValue="setValueLocation" :class="{ 'error': errors[0] }"/>
								<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
								<input type="hidden" v-model="model.id_location">
							</ValidationProvider>
		                </div>
		                <div class="form-group mt-0 col-4 w-m-full no-flex mr-0 ml-m-0">
		                    <label class="form-label">Kode pos</label>
							<ValidationProvider name="Kode pos" rules="required" v-slot="{ errors }">
								<select v-model="model.id_kodepos" class="form-control" :class="{ 'error': errors[0] }">
									<option value="">Pilih Kode Pos</option>
									<option v-for="(data, index) in listKodepos" v-bind:value="data.id" :key="index">
										{{ data.kodepos }}
									</option>
								</select>
								<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
							</ValidationProvider>
		                </div>
		            </div>
		            <div class="form-group mb-0">
		                <label class="form-label">Alamat Lengkap</label>
		                <ValidationProvider name="Alamat" rules="required" v-slot="{ errors }">
					        <input type="text" v-model="model.address" class="form-control" :class="{ 'error': errors[0] }" placeholder="Nama jalan, nomor rumah, gedung, dsb.">   
							<small style="color: red !important;" v-if="errors[0]">{{ errors[0] }}</small>
				    	</ValidationProvider>
		            </div>
					<div class="form-group">
		                <label class="form-label mt-2">Kordinat lokasi (optional) <a data-toggle="modal" href="#modalPilihKordinat" class="link"> Pilih Kordinat</a></label>            
		                <GmapMap
								class		="maps mb-2"
								:center		= map.center
								:options	= mapOptions
								:zoom		= map.zoom
								style		="height: 150px"
								@click		= addMarker
						>
							<gmap-marker
									v-for="(item, index) in markers"
									:key="index"
									:position="item"
							/>
						</GmapMap>
						<p class="f-14"><b>{{ map.address }} </b><a href="javascript:;" class="link float-right" @click="delKoor">Hapus Kordinat</a></p>
					</div>
		        </div>  
		    </div>    
		    <hr>
		    
		    <button type="submit" class="float-right btn btn-primary col-2 mb-3 w-m-1-2 margin-5 pd-10-20">Simpan</button>
		</ValidationObserver>

		<div class="modal fade" id="modalPilihKordinat" tabindex="-1" role="dialog" aria-labelledby="modalPilihKordinatTitle" aria-hidden="true">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Pilih Kordinat</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                </p>
		                <div class="mt-2 f-14" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
		                    Pastikan lokasi yang kamu pilih tidak berbeda jauh dengan alamat yang kamu isi di kolom alamat.
		                </div>
		                <gmap-autocomplete
								@place_changed="setPlace"
								class="form-control"
						>
						</gmap-autocomplete>
						<GmapMap
								class		= "maps mb-2"
								style		= "height: 330px"
								:center		= map.center
								:options	= mapOptions 
								:zoom		= map.zoom							
								@click		= addMarker 
						>
							<gmap-marker
									v-for="(item, index) in markers"
									:key="index"
									:position="item"
							/>
						</GmapMap>
						<p class="f-14"><b>{{ map.address }} </b></p>
		                <button type="button" class="float-right btn btn-primary col-2 w-m-1-2 mt-2 margin-5 pd-10-20" data-dismiss="modal">Simpan</button>
		            </div>
		        </div>
		    </div>
		</div>
	</section>
</template>

<script>
import SelectOption from './SelectOption'
import Vue from "vue"

export default {
	name: 'Form',
	components: {
		SelectOption
	},
	data() {
		return {
			model: {
				name			: '',
				phone_number	: '',
				address			: '',				
				id_country		: '',
				id_location		: '',
				lat				: '',
				lang			: '',
				id_kodepos  	: ''
			},
			mapOptions	: {
				streetViewControl	: false,
				fullscreenControl	: false,
				mapTypeControl		: false,
			},
			markers		: [],
			map			: {
			    address	: '',
			    place	: '',
                center	: { 
					lat	: -2.2145852388265177, 
					lng	: 117.104081069627 
				},
                zoom	: 4
			},
			listKodepos : [],
		}
	},
	beforeMount() {
		let _ = this

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		create() {
			let _ = this
			let data = _.model
			_.axios.post('contact', data )
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'ContactIndex',
							params: {
								status: 'insert'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}

			_.axios.patch('/contact', update)
				.then(resp => {
					if ( resp.data.status ) {
						_.$router.push({
							name: 'ContactIndex',
							params: {
								status: 'update'
							}
						})
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		getData() {
			let _ = this
			_.axios.get('/contact?id=' + _.$route.params.id)
				.then(resp => {
					let getData = resp.data.data.rows
					_.model = {
						name: getData.name,
						phone_number: getData.phone_number,
						address: getData.address,
						id_country: getData.id_country,
						id_location: getData.id_location,
						lat: getData.lat,
						lng: getData.lng,
						id_kodepos: getData.id_kodepos				
					}

					if(getData.lat != null && getData.lng != null){
						var latLng = {
							lat: parseFloat(getData.lat),
							lng: parseFloat(getData.lng)
						}

						_.markers 		= [latLng]
						_.map.center 	= latLng
						_.map.zoom 		= 18

						Vue.$geocoder.send(latLng,
							response => {
								_.map.address = response.results[0].formatted_address
							})
					}				
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
		setValueCountry(val) {
			let _ = this
			_.model.id_country = val
		},
		setValueLocation(val) {
			let _ = this
			_.model.id_location = val
		},
		setPlace(place){
		    let _ = this
			let latLng = {
                lat: parseFloat(place.geometry.location.lat()),
                lng: parseFloat(place.geometry.location.lng()),
			}
			_.map.place 	= place
            _.markers 		= [latLng]
			_.map.center 	= latLng
			_.map.zoom 		= 18

            Vue.$geocoder.send(latLng,
                response => {
                    _.map.address = response.results[0].formatted_address
				})
			
			_.model.lat = parseFloat(place.geometry.location.lat())
			_.model.lng = parseFloat(place.geometry.location.lng())
		},
		addMarker(data) {
		    let _ = this
			_.markers = [{
                lat: parseFloat(data.latLng.lat()),
                lng: parseFloat(data.latLng.lng()),
			}]

            Vue.$geocoder.send({
                    lat: parseFloat(data.latLng.lat()),
                    lng: parseFloat(data.latLng.lng()),
				},
                response => {
                    _.map.address = response.results[0].formatted_address
				})

			_.model.lat = parseFloat(data.latLng.lat())
			_.model.lng = parseFloat(data.latLng.lng())
		},
		getKodePos(id){
			let _ = this
			_.axios.get('location?id=' + id )
				.then(resp => {
					_.listKodepos = resp.data.data.rows.kodepos
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
		},
        delKoor() {
            let _ 			= this
            _.markers 		= []
			_.map.address 	= ''
			_.model.lat		= null
			_.model.lng		= null
		},
		async handleSubmit(){
			let _ = this
			const isValid = await this.$refs.observer.validate()
			if (isValid) {
				if (_.$route.params.id){
					_.update()
				} else {
					_.create()
				}
			}
		}
	},
	watch:{
		'model.id_location': function () {
			this.getKodePos(this.model.id_location)
		}
	}	
}
</script>